<template>
  <div>
    <div class="mt-4">
      <AnnouncementBar />
    </div>
    <div class="tabs">
      <ul>
        <li v-for="thisFilter in filters" v-bind:key="thisFilter.key">
          <button :class="['btn', { active: filter == thisFilter.key }]" v-on:click="setFilter(thisFilter.key)">
            {{ thisFilter.name }}
            <span class="count">{{ getCount(thisFilter.key) }}</span>
          </button>
        </li>
      </ul>
      <div class="toggles-wrapper">
        <div class="toggles">
          <span class="mr-2">Visible to customer:</span>
          <div class="toggle-container">
            <Toggle v-model="showSuiteTypes" />
            <span >Suite Types</span>
            <Toggle v-model="showIndividualSuites" />
            <span >Individual Suites</span>
          </div>
        </div>
      </div>
      <button class="btn btn-red add-suite" v-on:click="showAddSuite">
        <svg width="11px" height="11px" viewBox="0 0 11 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Suites-Availability" transform="translate(-1215.000000, -123.000000)">
              <g id="Group-9" transform="translate(1200.000000, 108.000000)">
                <polygon id="+" fill="#FFFFFF" fill-rule="nonzero" points="21.12 26 21.12 22.02 25.1 22.02 25.1 19.88 21.12 19.88 21.12 15.9 18.98 15.9 18.98 19.88 15 19.88 15 22.02 18.98 22.02 18.98 26"></polygon>
              </g>
            </g>
          </g>
        </svg>
        <span>Add new suite</span>
      </button>
    </div>
    <div v-if="alert" class="alert" v-html="alert"></div>
    <div class="suites">
      <draggable v-model="filteredSuites" ghost-class="ghost"
      @change="onDragEnd">
        <div v-for="suite in filteredSuites" v-bind:key="suite.id" :style="{ borderLeft: `4px solid ${suite.color}` }">
          <form v-on:submit.prevent="quickEdit(suite)">
            <div :class="['suite', 'row', { loading: suite.isLoading }]">
              <div class="col drag-col"></div>
              <div class="col-md-1 floorplan-col">
                <img :src="suite.floorplanSm" />
              </div>
              <div class="col-md-2 unit-col" v-if="!suite.isSuiteType">
                <div class="unit">Unit {{ suite.unit }}</div>
                <div class="size">{{ suite.size }} sq.ft. - {{ suite.floor }} Floor</div>
              </div>
              <div class="col-md-2 unit-col" v-else>
                <div class="unit">Type: {{ suite.name }}</div>
                <div class="size">
                  {{ suite.size }} sq.ft. <span class="count" :style="{ background: `${suite.color}` }">{{ getNumberOfUnitsForType(suite.id) }}</span>
                </div>
              </div>
              <div class="col-md-3 status-col">
                <label :for="`status-${suite.id}`">Status:</label>
                <select :id="`status-${suite.id}`" class="form-control" v-model="suite.availableTemp" v-on:change="changeStatus(suite, $event)">
                  <option :value="true">Available</option>
                  <option :value="false">Unavailable</option>
                </select>
              </div>
              <div class="col-md-3 cost-col">
                <label :for="`cost-${suite.id}`">Monthly Cost:</label>
                <input type="text" :id="`cost-${suite.id}`" :class="['form-control', { 'error': suite.rentError }]" v-model="suite.rentTemp" />
              </div>
              <div class="col-md-2 edit-col">
                <button class="btn btn-red-outline btn-block" type="button" v-on:click="showAddSuite($event, suite)">Edit</button>
                <button class="hidden" type="submit">Save</button>
              </div>
              <div class="spinner-container" v-if="suite.isLoading">
                <span class="spinner-border spinner-border-sm" role="status"></span>
              </div>
              <div class="col-12 error-col" v-if="suite.error">
                <p>{{ suite.error }}</p>
              </div>
            </div>
          </form>
        </div>
      </draggable>
    </div>
    <EditSuite :open="isSuitesOpen" :close="hideAddSuite" :suite="editSuite" :suiteTypes="suiteTypes" />
  </div>
</template>

<script>
import axios from "axios";
import AnnouncementBar from "../components/AnnouncementBar";
import EditSuite from "../components/EditSuite.vue";
import Toggle from "../components/Toggle";
import draggable from 'vuedraggable'
import Color from 'color';
const COLORS = ["#e39e43","#a9d24c","#3f77e2","#e03fe2","#e23f3f","#3fe287","#35aec1","#e2733f","#514cd2","#8fe23f"];
export default {
  name: 'Suites',
  data: function () {
    return {
      suites: [],
      isSuitesOpen: false,
      alert: "",
      filter: "all",
      filters: [
        {
          key: "all",
          name: "All"
        },
        {
          key: "available",
          name: "Available"
        },
        {
          key: "soon",
          name: "Coming Soon"
        },
        {
          key: "unavailable",
          name: "Unavailable"
        },
      ],
      editSuite: null,
      showSuiteTypes: false,
      showIndividualSuites: false,
    };
  },
  computed: {
    filteredSuites: {
        get() {
            let suites = [];
            this.suites.forEach((suite) => {
              if (this.filter == "available" && suite.availableNow) {
                suites.push(suite);
              }
              else if (this.filter == "unavailable" && !suite.available) {
                suites.push(suite);
              }
              else if (this.filter == "soon" && suite.available) {
                suites.push(suite);
              }
              else if (this.filter == "all") {
                suites.push(suite);
              }
            });

            return suites;
        },
        set(value) {
            this.suites = value;
        }
    },
    suiteTypes: function() {
      let suiteTypes = [];
      this.suites.forEach((suite) => {
        if (suite.isSuiteType) {
          suiteTypes.push({id: suite.id, name: suite.name});
        }
      });
      return suiteTypes;
    },
  },
  mounted: function () {
    axios.get('/api/suites/admin/read')
      .then((response) => {
        if (response.data.suites) {
          let suiteCounter = 0;
          for(let i = 0; i < response.data.suites.length; i++) {
            const suite = response.data.suites[i];
            this.setTempProperties(suite);
            if(suite.isSuiteType){
              const colorIndex = suiteCounter % COLORS.length ;
              const color = Color(COLORS[colorIndex]);
              suite.color = color.hex();
              suiteCounter++;
            }
              
          }
          this.suites = response.data.suites.sort((a,b)=>a.order-b.order);

          if (this.$route.params.suiteId) {
            for (let i = 0; i < this.suites.length; i++) {
              if (this.suites[i].id == this.$route.params.suiteId) {
                this.showAddSuite(null, this.suites[i]);
                break;
              }
            }
          }
        }
      });
      axios.get(`/api/config/read`)
          .then(response => {
            console.log(response.data);
            if(response.data.config){
              this.showSuiteTypes = response.data.config.showSuiteTypes;
              this.showIndividualSuites = response.data.config.showSuites;
            }
          })
          .catch(console.error)
  },
  watch: {
    showSuiteTypes: {
      immediate: false, 
      handler (showSuiteTypes, oldVal) {
        if(showSuiteTypes!=oldVal && ( typeof(this.showIndividualSuites) != "undefined")) {
          this.changeMasterToggle(showSuiteTypes, this.showIndividualSuites);
        }
      }
    },
    showIndividualSuites: {
      immediate: false, 
      handler (showIndividualSuites, oldVal) {
        if(showIndividualSuites!=oldVal&&( typeof(this.showSuiteTypes) != "undefined")) {
          this.changeMasterToggle(this.showSuiteTypes, showIndividualSuites);
        }
      }
    }
  },
  methods: {
    onDragEnd :function(e) {
      console.log(e.moved);
      const data = []; // [{suiteId,orderNumber}]
      
      for(let i = 0; i < this.suites.length; i++) {
        data.push({suiteId:this.suites[i].id, orderNumber:i});
      }

      let reqData = new FormData();
      reqData.append('data', JSON.stringify(data));

      axios.post(`/api/suites/saveSuiteOrder`, reqData)
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
      
    },
    changeStatus: function(suite) {
      this.quickEdit(suite);
    },
    showAddSuite: function (e, suite) {
      this.editSuite = suite || null;
      this.isSuitesOpen = true;
    },
    hideAddSuite: function (e, suite) {
      this.isSuitesOpen = false;
      if (suite) {
        if (this.editSuite) {
          this.alert = `<strong>Unit ${(suite.isSuiteType ? suite.name : suite.unit)}</strong> has been updated successfully`;

          for (let i = 0; i < this.suites.length; i++) {
            if (this.suites[i].id == suite.id) {
              this.setTempProperties(suite);
              this.$set(this.suites, i, suite);
            }
          }
        }
        else {
          this.alert = `<strong>Unit ${(suite.isSuiteType ? suite.name : suite.unit)}</strong> has been added successfully`;
          this.setTempProperties(suite);
          this.suites.push(suite);
          // to-do, re-order the suites
        }
        this.editSuite = null;
      }
    },
    setFilter: function(filter) {
      this.filter = filter;
    },
    changeMasterToggle: function(flagSuiteType, flagIndividualSutes) {
      console.log({flagSuiteType, flagIndividualSutes})
      
      let reqData = new FormData();
      reqData.append('showSuites', flagIndividualSutes);
      reqData.append('showSuiteTypes', flagSuiteType);
      axios.post(`/api/config/save`, reqData)
          .then(console.log)
          .catch(console.error)
    },
    quickEdit: function(suite) {
      this.$set(suite, 'rentError', null);
      this.$set(suite, 'isLoading', false);
      this.$set(suite, 'error', null);

      if (suite.available && !suite.rent) {
        this.$set(suite, 'rentError', true);
        this.$set(suite, 'error', "The monthly cost field is required.");
      }
      else {
        this.$set(suite, 'isLoading', true);

        let reqData = new FormData();
        reqData.append('available', suite.availableTemp);
        reqData.append('rent', suite.rentTemp);
        reqData.append('availableOn', '');

        axios.post(`/api/suites/${suite.id}/save`, reqData)
          .then((response) => {
            suite.isLoading = false;
            for(let i = 0; i < this.suites.length; i++) {
              if (this.suites[i].id == response.data.suite.id) {
                this.setTempProperties(response.data.suite);
                this.$set(this.suites, i, response.data.suite);
                break;
              }
            }
          })
          .catch((error) => {
            suite.isLoading = false;
            if (error.response) {
              let errorStr = "";
              if (error.response.data.error) {
                errorStr = error.response.data.error;
              }
              else if (error.response.data.errors) {
                errorStr = error.response.data.errors[Object.keys(error.response.data.errors)[0]][0];
              }
              else {
                errorStr = error.response.data.message;
              }

              this.$set(suite, 'error', errorStr);
            }
            else {
              this.$set(suite, 'error', "Sorry, something went wrong. Please try again later.");
            }
          });
      }
    },
    setTempProperties: function(suite) {
      suite.availableTemp = suite.available;
      suite.rentTemp = suite.rent;
    },
    getCount: function(filter) {
      let count = 0;
      this.suites.forEach((suite) => {
        if (filter == "available" && suite.availableNow) {
          count++;
        }
        else if (filter == "unavailable" && !suite.available) {
          count++;
        }
        else if (filter == "soon" && suite.available) {
          count++;
        }
        else if (filter == "all") {
          count++;
        }
      });
      return count;
    },
    getNumberOfUnitsForType: function(typeId) {
      let count = 0;
      this.suites.forEach((suite) => {
        if (!suite.isSuiteType && suite.typeId == typeId) {
          count++;
        }
      });
      if (count == 1) {
        return `${count} unit`;
      }
      else {
        return `${count} units`;
      }
    },
  },
  components: {
    EditSuite,
    draggable,
    AnnouncementBar,
    Toggle
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables";
.btn.add-suite {
  display: flex;
  align-items: center;

  svg {
    margin: 0 0.5em 0 0;
  }
}
div.tabs {
  flex-wrap: wrap-reverse;
  .toggles-wrapper{
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items:center;
      flex-grow: 1;
    .toggles {
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-size: 14px;
      font-weight: 400;
      &>span{
        font-size: 11px;
        color:#848484;
        margin-bottom: 5px;
      }
      .toggle-container{
        display: flex;
        flex-direction: row;
        font-size: 12px;
        color: #000;
        letter-spacing: 0;
        font-weight: 500;
        &>span{
          margin-right: 10px;
          margin-left: 10px;
        }
      }
    }
  }
  
}
div.suites {
  margin-bottom: 3rem;
  .ghost {
    opacity: 0;
  }
  div.suite {
    background-color: white;
    border-top: 1px solid #ECECEC;
    border-bottom: 1px solid #ECECEC;
    border-right: 1px solid #ECECEC;
    box-shadow: 0 10px 30px 0 rgba(0,0,0,0.07);
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    min-height: 84px;
    margin: 0 0 10px;
    position: relative;

    div.drag-col {
      background-image: url("../assets/icons/drag-control.svg");
      background-repeat: no-repeat;
      background-position: center;
      cursor:move;
      flex-shrink: 1;
      max-width: 50px;
    }

    div.floorplan-col {
      padding: 14px 15px;
      border-right: 1px solid #ECECEC;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;

      img {
        max-width: 100%;
        max-height: 54px;
        height: auto;
      }
    }

    div.unit-col {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;

      div.unit {
        font-size: 1rem;
        font-weight: 500;
        line-height: 1.1875;
        color: black;
      }
      div.size {
        font-size: 0.75rem;
        line-height: 2;
        color: rgba(#222222, 0.56);

        span.count {
          color: white;
          font-weight: 700;
          display: inline-block;
          padding: 0 7px;
          border-radius: 3px;
          font-size: 0.7rem;
          margin: 4px 0px 4px 11px;
        }
      }
    }

    div.status-col,
    div.cost-col {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      label {
        margin: 0 1em 0 0;
      }

      .form-control {
        width: 100%!important;
        padding: 0.5rem 0.75rem!important;
        max-height: 2.5em;
      }
    }

    div.cost-col {
      .form-control {
        width: auto;

        &.error {
          border-color: $red;
        }
      }
    }

    div.edit-col {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      button.hidden {
        display: none;
      }
    }

    div.spinner-container {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      background-color: rgba(#4A4A4A, 0.25);
    }

    div.error-col {
      p {
        text-align: right;
        font-size: 0.75rem;
        color: $red;
        font-weight: 500;
      }
    }
  }
}
</style>
